import styled from 'styled-components'

import { NEUTRAL_COLOURS } from 'constants/colors'

export const StyledFieldItem = styled.div`
  background: ${NEUTRAL_COLOURS.WHITE};
  border-bottom: 1px solid ${NEUTRAL_COLOURS.GRAY_SECONDARY};
  margin-bottom: 2px;
  padding: 12px 16px 12px 24px;
`
